import api from './api';

export default {
  async getKeys(params = {}) {
    const { data } = await api.get('/admin/translations/keys', { params });
    return data;
  },

  async createKey(payload) {
    const { data } = await api.post('/admin/translations/keys', payload);
    return data;
  },

  async updateKey(id, payload) {
    const { data } = await api.patch(`/admin/translations/keys/${id}`, payload);
    return data;
  },

  async getKey(id) {
    const { data } = await api.get(`/admin/translations/keys/${id}`);
    return data;
  },

  async deleteKey(id) {
    const { data } = await api.delete(`/admin/translations/keys/${id}`);
    return data;
  },

  async updateTranslations(keyId, values) {
    const { data } = await api.put(`/admin/translations/keys/${keyId}/values`, values);
    return data;
  },

  async autoTranslate(payload) {
    const { data } = await api.post('/admin/translations/auto-translate', payload);
    return data;
  },

  async getLocales() {
    const { data } = await api.get('/admin/translations/locales');
    return data;
  },

  async suggestKey(params) {
    const { data } = await api.get('/admin/translations/keys/suggest', { params });
    return data;
  },

  async getNamespaces() {
    const { data } = await api.get('/admin/translations/namespaces');
    return data;
  },
};